import { render, staticRenderFns } from "./TaskRaiting.vue?vue&type=template&id=359acb4e&"
import script from "./TaskRaiting.vue?vue&type=script&lang=js&"
export * from "./TaskRaiting.vue?vue&type=script&lang=js&"
import style0 from "./TaskRaiting.vue?vue&type=style&index=0&id=359acb4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports